export const allCountries = [
  ["Afghanistan (‫افغانستان‬‎)", "af", "93", "阿富汗", "🇦🇫", "AFG"],
  ["Albania (Shqipëri)", "al", "355", "阿尔巴尼亚", "🇦🇱", "ALB"],
  ["Algeria (الجزائر‎)", "dz", "213", "阿尔及利亚", "🇩🇿", "DZA"],
  ["Andorra", "ad", "376", "安道尔共和国", "🇦🇩", "AND"],
  ["Angola", "ao", "244", "安哥拉", "🇦🇴", "AGO"],
  ["Anguilla", "ai", "1264", "安圭拉岛", "🇦🇮", "AIA"],
  ["Antigua and Barbuda", "ag", "1268", "安提瓜和巴布达", "🇦🇬", "ATG"],
  ["Argentina", "ar", "54", "阿根廷", "🇦🇷", "ARG"],
  ["Armenia (Հայաստան)", "am", "374", "亚美尼亚", "🇦🇲", "ARM"],
  ["Aruba", "aw", "297", "阿魯巴", "🇦🇼", "ABW"],
  ["Australia", "au", "61", "澳大利亚", "🇦🇺", "AUS"],
  ["Austria (Österreich)", "at", "43", "奥地利", "🇦🇹", "AUT"],
  ["Azerbaijan (Azərbaycan)", "az", "994", "阿塞拜疆", "🇦🇿", "AZE"],
  ["Bahamas", "bs", "1242", "巴哈马", "🇧🇸", "BHS"],
  ["Bahrain (‫البحرين‬‎)", "bh", "973", "巴林", "🇧🇭", "BHR"],
  ["Bangladesh (বাংলাদেশ)", "bd", "880", "孟加拉国", "🇧🇩", "BGD"],
  ["Barbados", "bb", "1246", "巴巴多斯", "🇧🇧", "BRB"],
  ["Belarus (Беларусь)", "by", "375", "白俄罗斯", "🇧🇾", "BLR"],
  ["Belgium (België)", "be", "32", "比利时", "🇧🇪", "BEL"],
  ["Belize", "bz", "501", "伯利兹", "🇧🇿", "BLZ"],
  ["Benin (Bénin)", "bj", "229", "贝宁", "🇧🇯", "BEN"],
  ["Bermuda", "bm", "1441", "百慕大群岛", "🇧🇲", "BMU"],
  ["Bhutan (འབྲུག)", "bt", "975", "不丹", "🇧🇹", "BTN"],
  ["Bolivia", "bo", "591", "玻利维亚", "🇧🇴", "BOL"],
  [
    "Bosnia and Herzegovina (Босна и Херцеговина)",
    "ba",
    "387",
    "波斯尼亚和黑塞哥维那",
    "🇧🇦",
    "BIH",
  ],
  ["Botswana", "bw", "267", "博茨瓦纳", "🇧🇼", "BWA"],
  ["Brazil (Brasil)", "br", "55", "巴西", "🇧🇷", "BRA"],
  [
    "British Indian Ocean Territory",
    "io",
    "246",
    "英属印度洋领地",
    "🇮🇴",
    "IOT",
  ],
  ["Brunei", "bn", "673", "文莱", "🇧🇳", "BRN"],
  ["Bulgaria (България)", "bg", "359", "保加利亚", "🇧🇬", "BGR"],
  ["Burkina Faso", "bf", "226", "布基纳法索", "🇧🇫", "BFA"],
  ["Burundi (Uburundi)", "bi", "257", "布隆迪", "🇧🇮", "BDI"],
  ["Cambodia (កម្ពុជា)", "kh", "855", "柬埔寨", "🇰🇭", "KHM"],
  ["Cameroon (Cameroun)", "cm", "237", "喀麦隆", "🇨🇲", "CMR"],
  ["Canada", "ca", "1", "加拿大", "🇨🇦", "CAN"],
  ["Cape Verde (Kabu Verdi)", "cv", "238", "佛得角", "🇨🇻", "CPV"],
  ["Caribbean Netherlands", "bq", "599", "荷属安的列斯", "🇧🇶", "BES"],
  ["Cayman Islands", "ky", "1345", "开曼群岛", "🇰🇾", "CYM"],
  [
    "Central African Republic (République centrafricaine)",
    "cf",
    "236",
    "中非共和国",
    "🇨🇫",
    "CAF",
  ],
  ["Chad (Tchad)", "td", "235", "乍得", "🇹🇩", "TCD"],
  ["Chile", "cl", "56", "智利", "🇨🇱", "CHL"],
  // ["China (中国)", "cn", "86", "中国", "🇨🇳", "CHN"],
  ["Christmas Island", "cx", "61", "圣诞岛", "🇨🇽", "CXR"],
  ["Cocos (Keeling) Islands", "cc", "61", "科科斯群岛", "🇨🇨", "CCK"],
  ["Colombia", "co", "57", "哥伦比亚", "🇨🇴", "COL"],
  ["Comoros (‫جزر القمر‬‎)", "km", "269", "科摩罗", "🇰🇲", "COM"],
  ["Congo (Republic) (Congo-Brazzaville)", "cg", "242", "刚果", "🇨🇬", "COG"],
  ["Cook Islands", "ck", "682", "库克群岛", "🇨🇰", "COK"],
  ["Costa Rica", "cr", "506", "哥斯达黎加", "🇨🇷", "CRI"],
  ["Côte d’Ivoire", "ci", "225", "科特迪瓦", "🇨🇮", "CIV"],
  ["Croatia (Hrvatska)", "hr", "385", "克罗地亚", "🇭🇷", "HRV"],
  ["Cuba", "cu", "53", "古巴", "🇨🇺", "CUB"],
  ["Curaçao", "cw", "599", "库拉索岛", "🇨🇼", "CUW"],
  ["Cyprus (Κύπρος)", "cy", "357", "塞浦路斯", "🇨🇾", "CYP"],
  ["Czech Republic (Česká republika)", "cz", "420", "捷克", "🇨🇿", "CZE"],
  ["Denmark (Danmark)", "dk", "45", "丹麦", "🇩🇰", "DNK"],
  ["Djibouti", "dj", "253", "吉布提", "🇩🇯", "DJI"],
  ["Dominica", "dm", "1767", "多米尼克", "🇩🇲", "DMA"],
  [
    "Dominican Republic (República Dominicana)",
    "do",
    "1",
    "多米尼加共和国",
    "🇩🇴",
    "DOM",
  ],
  ["Ecuador", "ec", "593", "厄瓜多尔", "🇪🇨", "ECU"],
  ["Egypt (مصر‎)", "eg", "20", "埃及", "🇪🇬", "EGY"],
  ["El Salvador", "sv", "503", "萨尔瓦多", "🇸🇻", "SLV"],
  [
    "Equatorial Guinea (Guinea Ecuatorial)",
    "gq",
    "240",
    "几内亚比绍",
    "🇬🇶",
    "GNQ",
  ],
  ["Eritrea", "er", "291", "非洲厄立特里亚", "🇪🇷", "ERI"],
  ["Estonia (Eesti)", "ee", "372", "爱沙尼亚", "🇪🇪", "EST"],
  ["Ethiopia", "et", "251", "埃塞俄比亚", "🇪🇹", "ETH"],
  ["Falkland Islands (Islas Malvinas)", "fk", "500", "斯坦利港", "🇫🇰", "FLK"],
  ["Faroe Islands (Føroyar)", "fo", "298", "法罗群岛 (托尔沙文)", "🇫🇴", "FRO"],
  ["Fiji", "fj", "679", "斐济", "🇫🇯", "FJI"],
  ["Finland (Suomi)", "fi", "358", "芬兰", "🇫🇮", "FIN"],
  ["France", "fr", "33", "法国", "🇫🇷", "FRA"],
  ["French Guiana (Guyane française)", "gf", "594", "法属圭亚那", "🇬🇫", "GUF"],
  [
    "French Polynesia (Polynésie française)",
    "pf",
    "689",
    "法属玻利尼西亚",
    "🇵🇫",
    "PYF",
  ],
  ["Gabon", "ga", "241", "加蓬", "🇬🇦", "GAB"],
  ["Gambia", "gm", "220", "冈比亚", "🇬🇲", "GMB"],
  ["Georgia (საქართველო)", "ge", "995", "格鲁吉亚", "🇬🇪", "GEO"],
  ["Germany (Deutschland)", "de", "49", "德国", "🇩🇪", "DEU"],
  ["Ghana (Gaana)", "gh", "233", "加纳", "🇬🇭", "GHA"],
  ["Gibraltar", "gi", "350", "直布罗陀", "🇬🇮", "GIB"],
  ["Greece (Ελλάδα)", "gr", "30", "希腊", "🇬🇷", "GRC"],
  ["Greenland (Kalaallit Nunaat)", "gl", "299", "格陵兰岛", "🇬🇱", "GRL"],
  ["Grenada", "gd", "1473", "格林纳达", "🇬🇩", "GRD"],
  ["Guadeloupe", "gp", "590", "瓜德罗普", "🇬🇵", "GLP"],
  ["Guam", "gu", "1671", "关岛", "🇬🇺", "GUM"],
  ["Guatemala", "gt", "502", "危地马拉", "🇬🇹", "GTM"],
  ["Guernsey", "gg", "44", "根西岛", "🇬🇬", "GGY"],
  ["Guinea (Guinée)", "gn", "224", "几内亚", "🇬🇳", "GIN"],
  ["Guinea-Bissau (Guiné Bissau)", "gw", "245", "几内亚比绍", "🇬🇼", "GNB"],
  ["Guyana", "gy", "592", "圭亚那", "🇬🇾", "GUY"],
  ["Haiti", "ht", "509", "海地", "🇭🇹", "HTI"],
  ["Honduras", "hn", "504", "洪都拉斯", "🇭🇳", "HND"],
  ["Hong Kong(香港), China", "hk", "852", "香港", "🇭🇰", "HKG"],
  ["Hungary (Magyarország)", "hu", "36", "匈牙利", "🇭🇺", "HUN"],
  ["Iceland (Ísland)", "is", "354", "冰岛", "🇮🇸", "ISL"],
  ["India (भारत)", "in", "91", "印度", "🇮🇳", "IND"],
  ["Indonesia", "id", "62", "印度尼西亚", "🇮🇩", "IDN"],
  ["Iran (ایران‎)", "ir", "98", "伊朗", "🇮🇷", "IRN"],
  ["Iraq (العراق‎)", "iq", "964", "伊拉克", "🇮🇶", "IRQ"],
  ["Ireland", "ie", "353", "爱尔兰", "🇮🇪", "IRL"],
  ["Isle of Man", "im", "44", "马恩岛", "🇮🇲", "IMN"],
  ["Israel (ישראל‎)", "il", "972", "以色列", "🇮🇱", "ISR"],
  ["Italy (Italia)", "it", "39", "意大利", "🇮🇹", "ITA"],
  ["Jamaica", "jm", "1876", "牙买加", "🇯🇲", "JAM"],
  ["Japan (日本)", "jp", "81", "日本", "🇯🇵", "JPN"],
  ["Jersey", "je", "44", "泽西岛", "🇯🇪", "JEY"],
  ["Jordan (‫الأردن‬‎)", "jo", "962", "约旦", "🇯🇴", "JOR"],
  ["Kazakhstan (Казахстан)", "kz", "7", "哈萨克斯坦", "🇰🇿", "KAZ"],
  ["Kenya", "ke", "254", "肯尼亚", "🇰🇪", "KEN"],
  ["Kiribati", "ki", "686", "基里巴斯", "🇰🇮", "KIR"],
  ["Kosovo", "xk", "383", "科索沃", "🇽🇰"],
  ["Kuwait (الكويت‎)", "kw", "965", "科威特", "🇰🇼", "KWT"],
  ["Kyrgyzstan (Кыргызстан)", "kg", "996", "吉尔吉斯坦", "🇰🇬", "KGZ"],
  ["Laos (ລາວ)", "la", "856", "老挝", "🇱🇦", "LAO"],
  ["Latvia (Latvija)", "lv", "371", "拉脱维亚", "🇱🇻", "LVA"],
  ["Lebanon (لبنان‎)", "lb", "961", "黎巴嫩", "🇱🇧", "LBN"],
  ["Lesotho", "ls", "266", "莱索托", "🇱🇸", "LSO"],
  ["Liberia", "lr", "231", "利比里亚", "🇱🇷", "LBR"],
  ["Libya (‫ليبيا‬‎)", "ly", "218", "利比亚", "🇱🇾", "LBY"],
  ["Liechtenstein", "li", "423", "列支敦士登", "🇱🇮", "LIE"],
  ["Lithuania (Lietuva)", "lt", "370", "立陶宛", "🇱🇹", "LTU"],
  ["Luxembourg", "lu", "352", "卢森堡", "🇱🇺", "LUX"],
  ["Macau(澳門), China", "mo", "853", "澳门", "🇲🇴", "MAC"],
  ["Macedonia (FYROM) (Македонија)", "mk", "389", "北马其顿", "🇲🇰", "MKD"],
  ["Madagascar (Madagasikara)", "mg", "261", "马达加斯加", "🇲🇬", "MDG"],
  ["Malawi", "mw", "265", "马拉维", "🇲🇼", "MWI"],
  ["Malaysia", "my", "60", "马来西亚", "🇲🇾", "MYS"],
  ["Maldives", "mv", "960", "马尔代夫", "🇲🇻", "MDV"],
  ["Mali", "ml", "223", "马里", "🇲🇱", "MLI"],
  ["Malta", "mt", "356", "马耳他", "🇲🇹", "MLT"],
  ["Marshall Islands", "mh", "692", "马绍尔群岛共和国", "🇲🇭", "MHL"],
  ["Martinique", "mq", "596", "马提尼克", "🇲🇶", "MTQ"],
  ["Mauritania (‫موريتانيا‬‎)", "mr", "222", "毛里塔尼亚", "🇲🇷", "MRT"],
  ["Mauritius (Moris)", "mu", "230", "毛里求斯", "🇲🇺", "MUS"],
  ["Mayotte", "yt", "262", "留尼旺", "🇾🇹", "MYT"],
  ["Mexico (México)", "mx", "52", "墨西哥", "🇲🇽", "MEX"],
  ["Micronesia", "fm", "691", "密克罗尼西亚", "🇫🇲", "FSM"],
  ["Moldova (Republica Moldova)", "md", "373", "摩尔多瓦", "🇲🇩", "MDA"],
  ["Monaco", "mc", "377", "摩纳哥", "🇲🇨", "MCO"],
  ["Mongolia (Монгол)", "mn", "976", "蒙古", "🇲🇳", "MNG"],
  ["Montenegro (Crna Gora)", "me", "382", "黑山", "🇲🇪", "MNE"],
  ["Montserrat", "ms", "1664", "蒙特塞拉特岛", "🇲🇸", "MSR"],
  ["Morocco (المغرب‎)", "ma", "212", "摩洛哥", "🇲🇦", "MAR"],
  ["Mozambique (Moçambique)", "mz", "258", "莫桑比克", "🇲🇿", "MOZ"],
  ["Myanmar (Burma) (မြန်မာ)", "mm", "95", "缅甸", "🇲🇲", "MMR"],
  ["Namibia (Namibië)", "na", "264", "纳米比亚", "🇳🇦", "NAM"],
  ["Nauru", "nr", "674", "瑙鲁", "🇳🇷", "NRU"],
  ["Nepal (नेपाल)", "np", "977", "尼泊尔", "🇳🇵", "NPL"],
  ["Netherlands (Nederland)", "nl", "31", "荷兰", "🇳🇱", "NLD"],
  [
    "New Caledonia (Nouvelle-Calédonie)",
    "nc",
    "687",
    "新喀里多尼亚群岛",
    "🇳🇨",
    "NCL",
  ],
  ["New Zealand", "nz", "64", "新西兰", "🇳🇿", "NZL"],
  ["Nicaragua", "ni", "505", "尼加拉瓜", "🇳🇮", "NIC"],
  ["Niger (Nijar)", "ne", "227", "尼日尔", "🇳🇪", "NER"],
  ["Nigeria", "ng", "234", "尼日利亚", "🇳🇬", "NGA"],
  ["Niue", "nu", "683", "纽埃", "🇳🇺", "NIU"],
  ["Norfolk Island", "nf", "672", "诺福克岛", "🇳🇫", "NFK"],
  ["North Korea (조선 민주주의 인민 공화국)", "kp", "850", "朝鲜", "🇰🇵", "PRK"],
  ["Northern Mariana Islands", "mp", "1670", "马里亚那群岛", "🇲🇵", "MNP"],
  ["Norway (Norge)", "no", "47", "挪威", "🇳🇴", "NOR"],
  ["Oman (عُمان‎)", "om", "968", "阿曼", "🇴🇲", "OMN"],
  ["Pakistan (پاکستان‎)", "pk", "92", "巴基斯坦", "🇵🇰", "PAK"],
  ["Palau", "pw", "680", "帕劳", "🇵🇼", "PLW"],
  ["Palestine (‫فلسطين‬‎)", "ps", "970", "巴勒斯坦", "🇵🇸", "PSE"],
  ["Panama (Panamá)", "pa", "507", "巴拿马", "🇵🇦", "PAN"],
  ["Papua New Guinea", "pg", "675", "巴布亚新几内亚", "🇵🇬", "PNG"],
  ["Paraguay", "py", "595", "巴拉圭", "🇵🇾", "PRY"],
  ["Peru (Perú)", "pe", "51", "秘鲁", "🇵🇪", "PER"],
  ["Philippines", "ph", "63", "菲律宾", "🇵🇭", "PHL"],
  ["Poland (Polska)", "pl", "48", "波兰", "🇵🇱", "POL"],
  ["Portugal", "pt", "351", "葡萄牙", "🇵🇹", "PRT"],
  ["Qatar (قطر‎)", "qa", "974", "卡塔尔", "🇶🇦", "QAT"],
  ["Réunion (La Réunion)", "re", "262", "留尼旺", "🇷🇪", "REU"],
  ["Romania (România)", "ro", "40", "罗马尼亚", "🇷🇴", "ROU"],
  ["Russia (Россия)", "ru", "7", "俄罗斯", "🇷🇺", "RUS"],
  ["Rwanda", "rw", "250", "卢旺达", "🇷🇼", "RWA"],
  ["Saint Barthélemy", "bl", "590", "圣巴泰勒米", "🇧🇱", "BLM"],
  ["Saint Helena", "sh", "290", "圣赫勒拿", "🇸🇭", "SHN"],
  ["Saint Kitts and Nevis", "kn", "1869", "圣基茨和尼维斯", "🇰🇳", "KNA"],
  ["Saint Lucia", "lc", "1758", "圣卢西亚", "🇱🇨", "LCA"],
  [
    "Saint Martin (Saint-Martin (partie française))",
    "mf",
    "590",
    "法属圣马丁",
    "🇲🇫",
    "MAF",
  ],
  [
    "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    "pm",
    "508",
    "圣皮埃尔岛和密克隆岛时间",
    "🇵🇲",
    "SPM",
  ],
  ["Saint Vincent and the Grenadines", "vc", "1784", "圣文森特岛", "🇻🇨", "VCT"],
  ["Samoa", "ws", "685", "西萨摩亚", "🇼🇸", "WSM"],
  ["San Marino", "sm", "378", "圣马力诺", "🇸🇲", "SMR"],
  [
    "São Tomé and Príncipe (São Tomé e Príncipe)",
    "st",
    "239",
    "圣多美和普林西比",
    "🇸🇹",
    "STP",
  ],
  [
    "Saudi Arabia (المملكة العربية السعودية‎)",
    "sa",
    "966",
    "沙特阿拉伯",
    "🇸🇦",
    "SAU",
  ],
  ["Senegal (Sénégal)", "sn", "221", "塞内加尔", "🇸🇳", "SEN"],
  ["Serbia (Србија)", "rs", "381", "南斯拉夫", "🇷🇸", "SRB"],
  ["Seychelles", "sc", "248", "塞舌尔", "🇸🇨", "SYC"],
  ["Sierra Leone", "sl", "232", "塞拉利昂", "🇸🇱", "SLE"],
  ["Singapore", "sg", "65", "新加坡", "🇸🇬", "SGP"],
  ["Slovakia (Slovensko)", "sk", "421", "斯洛伐克", "🇸🇰", "SVK"],
  ["Slovenia (Slovenija)", "si", "386", "斯洛文尼亚", "🇸🇮", "SVN"],
  ["Solomon Islands", "sb", "677", "所罗门群岛", "🇸🇧", "SLB"],
  ["Somalia (Soomaaliya)", "so", "252", "索马里", "🇸🇴", "SOM"],
  ["South Africa", "za", "27", "南非", "🇿🇦", "ZAF"],
  ["South Korea (대한민국)", "kr", "82", "韩国", "🇰🇷", "KOR"],
  ["South Sudan (‫جنوب السودان‬‎)", "ss", "211", "南苏丹", "🇸🇸", "SSD"],
  ["Spain (España)", "es", "34", "西班牙", "🇪🇸", "ESP"],
  ["Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94", "斯里兰卡", "🇱🇰", "LKA"],
  ["Sudan (‫السودان‬‎)", "sd", "249", "苏丹", "🇸🇩", "SDN"],
  ["Suriname", "sr", "597", "苏里南", "🇸🇷", "SUR"],
  ["Svalbard and Jan Mayen", "sj", "47", "斯瓦巴和扬马延", "🇸🇯", "SJM"],
  ["Swaziland", "sz", "268", "斯威士兰", "🇸🇿", "SWZ"],
  ["Sweden (Sverige)", "se", "46", "瑞典", "🇸🇪", "SWE"],
  ["Switzerland (Schweiz)", "ch", "41", "瑞士", "🇨🇭", "CHE"],
  ["Syria (سوريا‎)", "sy", "963", "叙利亚", "🇸🇾", "SYR"],
  ["Taiwan(台灣), China", "tw", "886", "台灣", "", "TWN"],
  ["Tajikistan", "tj", "992", "塔吉克斯坦", "🇹🇯", "TJK"],
  ["Tanzania", "tz", "255", "坦桑尼亚", "🇹🇿", "TZA"],
  ["Thailand (ไทย)", "th", "66", "泰国", "🇹🇭", "THA"],
  ["Timor-Leste", "tl", "670", "东帝汶", "🇹🇱", "TLS"],
  ["Togo", "tg", "228", "多哥", "🇹🇬", "TGO"],
  ["Tokelau", "tk", "690", "托克劳", "🇹🇰", "TKL"],
  ["Tonga", "to", "676", "汤加", "🇹🇴", "TON"],
  ["Trinidad and Tobago", "tt", "1868", "特立尼达和多巴哥", "🇹🇹", "TTO"],
  ["Tunisia (تونس‎)", "tn", "216", "突尼斯", "🇹🇳", "TUN"],
  ["Turkey (Türkiye)", "tr", "90", "土耳其", "🇹🇷", "TUR"],
  ["Turkmenistan", "tm", "993", "土库曼斯坦", "🇹🇲", "TKM"],
  ["Turks and Caicos Islands", "tc", "1649", "特克斯和凯科斯群岛", "🇹🇨", "TCA"],
  ["Tuvalu", "tv", "688", "图瓦卢", "🇹🇻", "TUV"],
  ["Uganda", "ug", "256", "乌干达", "🇺🇬", "UGA"],
  ["Ukraine (Україна)", "ua", "380", "乌克兰", "🇺🇦", "UKR"],
  [
    "United Arab Emirates (الإمارات العربية المتحدة‎)",
    "ae",
    "971",
    "阿拉伯联合酋长国",
    "🇦🇪",
    "ARE",
  ],
  ["United Kingdom", "gb", "44", "英国", "🇬🇧", "GBR"],
  ["United States", "us", "1", "美国", "🇺🇸", "USA"],
  ["Uruguay", "uy", "598", "乌拉圭", "🇺🇾", "URY"],
  ["Uzbekistan (Oʻzbekiston)", "uz", "998", "乌兹别克斯坦", "🇺🇿", "UZB"],
  ["Vanuatu", "vu", "678", "瓦努阿图", "🇻🇺", "VUT"],
  ["Venezuela", "ve", "58", "委内瑞拉", "🇻🇪", "VEN"],
  ["Vietnam (Việt Nam)", "vn", "84", "越南", "🇻🇳", "VNM"],
  [
    "Wallis and Futuna (Wallis-et-Futuna)",
    "wf",
    "681",
    "瓦利斯和富图纳",
    "🇼🇫",
    "WLF",
  ],
  [
    "Western Sahara (‫الصحراء الغربية‬‎)",
    "eh",
    "212",
    "西撒哈拉 (艾恩)",
    "🇪🇭",
    "ESH",
  ],
  ["Yemen (اليمن‎)", "ye", "967", "也门", "🇾🇪", "YEM"],
  ["Zambia", "zm", "260", "赞比亚", "🇿🇲", "ZMB"],
  ["Zimbabwe", "zw", "263", "津巴布韦", "🇿🇼", "ZWE"],
  ["Åland Islands", "ax", "358", "芬兰", "🇦🇽", "ALA"],
  ["Bouvet Island", "bv", "47", "布韦岛", "🇧🇻", "BVT"],
  [
    "Congo, The Democratic Republic of the Congo",
    "cd",
    "243",
    "刚果民主共和国",
    "🇨🇩",
    "COD",
  ],
  ["Holy See (Vatican City State)", "va", "379", "蒂冈城国", "🇻🇦", "VAT"],
  ["Puerto Rico", "pr", "1939", "波多黎各自由邦", "🇵🇷", "PRI"],
  [
    "South Georgia and the South Sandwich Islands",
    "gs",
    "500",
    "南乔治亚和南桑威奇群岛",
    "🇬🇸",
    "SGS",
  ],
  ["Virgin Islands, U.S.", "vi", "1340", "美属维尔京群岛", "🇻🇮", "VIR"],
];
export const searchIndex = [
  "★",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const hotCity = [
  "us",
  "jp",
  "au",
  "hk",
  "ca",
  "sg",
  "gb",
  "de",
  "fr",
  "kr",
  "it",
  "nl",
  "th",
  "es",
  "my",
  "nz",
];